import React from 'react';
import GoogleAd from './GoogleAd';
import { AD_SLOTS } from './adConfig';

/**
 * Fixed vertical ad units that live in the empty white gutters on either side of the
 * centered page content. They are automatically hidden on narrower viewports where there
 * is no free horizontal space (so they never overlap the site content).
 *
 * Controlled entirely with CSS in custom.css (.metadb-side-rail).
 */
export default function SideRailAds() {
    return (
        <>
            <div className="metadb-side-rail metadb-side-rail-left" aria-hidden="true">
                <GoogleAd
                    slot={AD_SLOTS.sideRailLeft}
                    format="vertical"
                    responsive={false}
                    label="Side Rail 160x600"
                    style={{ display: 'block', width: 160, height: 600 }}
                />
            </div>
            <div className="metadb-side-rail metadb-side-rail-right" aria-hidden="true">
                <GoogleAd
                    slot={AD_SLOTS.sideRailRight}
                    format="vertical"
                    responsive={false}
                    label="Side Rail 160x600"
                    style={{ display: 'block', width: 160, height: 600 }}
                />
            </div>
        </>
    );
}
